<template>
  <div class="page-wrap login-page">
    <img class="bg-img" :src="backgroundUrl" />
    <!-- <div class="bg-img-background"></div> -->
    <div class="header">
      <div class="logo-wrap">
        <img src="@/assets/images/logo.png" alt="数智文博精卫计划创作者中心" />
      </div>
    </div>
    <div class="footer">
      <span
        >Copyright©湖南芒果数智艺术科技有限责任公司 shuziwenbo.cn 版权所有 &nbsp;&nbsp;&nbsp;&nbsp; 湘ICP备2024069118号-1
        &nbsp;&nbsp;&nbsp;&nbsp;湘公网安备43010502001703</span
      >
    </div>
    <!-- <div class="page-title"></div> -->
    <div class="page-center">
      <div class="title"></div>
      <LoginBox @handleLoginSuccess="handleLoginSuccess" />
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
import { getBanner } from '@/servies/index.js';
import LoginBox from '@/components/LoginBox.vue'
import { mapState } from 'vuex'
export default {
  name: 'loginIndex',
  data() {
    return {
      checkLoginTimer: false,
      loginTarget: '',
      backgroundUrl:''
    }
  },
  components: {
    LoginBox
  },
  computed: {
    ...mapState(['isLogin', 'userInfo']),
  },
 
  beforeDestroy() {
    if (this.checkLoginTimer) clearInterval(this.checkLoginTimer)
  },

  mounted() {
    this.checkLogin()
    this.checkLoginTimer = setInterval(() => {
      this.checkLogin()
    }, 200)

    getBanner({ did: this.$utils.getSTKUUID()}).then((response) => {
      if (response.data.code === 200) {
        this.backgroundUrl = `${response.data.data[0]?.contents[0]?.contentImage}?imageView2/1/format/webp/q/90`
      }
    })

    
  },

  methods: {
    async checkLogin () {
      if (this.$utils.getUserToken()) {
        setTimeout(() => {
          this.$router.push({ path: '/publish' }, () => {})
        }, 200);
      }
    },
    handleLoginSuccess(data) {
      console.log('handleLoginSuccess:', data)
      if (this.checkLoginTimer) clearInterval(this.checkLoginTimer)
      this.checkLogin()
    }
  },
  watch: {}
}
</script>
<style lang="less" scoped>
.login-page {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow:hidden;


  .bg-img {
    position: relative;
    width: 100vw;
    height: 100vh;
    object-fit: cover;
    z-index: 1;
    
  }
  .bg-img-background{
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    background-image: url('@/assets/images/sh-mp-bg.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .header {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 68px;
    background: #F5F8FA;  
    backdrop-filter: blur(15px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo-wrap{
      margin-left: 20px;
      width: 182px;
      height: 24px;
      img{
        width: 100%;
        height: 100%;
        display: block;
      }
    }

    // .right-container {
    //   margin-right: 36px;
    //   font-size: 16px;
    //   font-family: PingFang SC;
    //   font-weight: 400;
    //   color: #ffffff;
    //   line-height: 100%;
    //   display: inline-block;
    //   vertical-align: middle;
    //   a {
    //     color: #ffffff;
    //     margin: 0 8px;
    //   }
    // }
  }

  .footer {
    position: absolute;
    bottom: 5px;
    z-index: 2;
    width: 100%;
    height: 70px;
    font-size: 12px;
    color: #a5aeb5;
    line-height: 70px;
    text-align: center;
  }
  .page-title{
    z-index: 2;
    position: absolute;
    left: 8%;
    top: 50%;
    margin-top: -50px;
    width: 500px;
    height: 100px;
    background: red;
  }
  .page-center {
    .title{
      position: absolute;
      left: 50%;
      top: 24%;
      margin-left: -269px;
      z-index: 2;
      width: 537px;
      height: 72px;
      background: url('@/assets/images/title_bg.png') center center no-repeat;
    }
    // z-index: 2;
    // position: absolute;
    // top: 30%;
    // left: 50%;
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    // align-items: flex-start;
  }
}
</style>
